import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { validationsQuestionsDynamiques } from 'src/app/shared/questionnaire.metadata';
import { ValidationService } from '../../../../shared/validation/validation.service';
import { FormulaireService } from '../../../formulaire.service';
import { ModeRenduService } from '../../../mode-rendu/mode-rendu.service';
@Component({
  selector: 'bis-lieux-hosto',
  templateUrl: './lieux-hosto.component.html',
  styleUrls: ['./lieux-hosto.component.css']
})
export class LieuxHostoComponent implements OnInit, OnDestroy {
  public rootForm: UntypedFormGroup;
  step: number = 0;
  @Input()
  erreursMap: Map<string, string>;
  
  private subLieuxHosto: Subscription;
  private valeurTableauA4g_1: number[] = [];
  private valeurTableauA4g_2: number[] = [];
  private valeurTableauA4g_3: number[] = [];

  constructor(
    private formulaireService: FormulaireService,
    private validationService: ValidationService,
    public modeRenduService: ModeRenduService
  ) {
    this.rootForm = this.formulaireService.getRootForm();
    if (! this.lieuxHosto) {
      (this.rootForm.get('moyens') as UntypedFormGroup).setControl('lieuxHosto', new UntypedFormArray([]));
    }
   }

  ngOnInit(): void {
    setTimeout(() => {
      //Controles bloquants
      for (let index = 0; index < this.lieuxHosto.length; index++) {
        this.ajoutValidateurCroiseLieuxHosto(index);
        this.lieuxHosto.controls[index].updateValueAndValidity();
      }

      // Tri apres rechargement questionnaire
      this.trierLieuxHosto();
    
      // Calcul des totaux lieux hosto
      this.subLieuxHosto = this.lieuxHosto.valueChanges.pipe(distinctUntilChanged(),debounceTime(100)).subscribe(valeur => {
          if (valeur instanceof Array) {

            this.valeurTableauA4g_1 = [];
            this.valeurTableauA4g_2 = [];
            this.valeurTableauA4g_3 = [];
            
            valeur.forEach((lieux, index) => {
              //Calcul totaux auto A4g
              this.calculAutoTotauxA4g(index, this.valeurTableauA4g_1, 'aaLieuHostoNbPerm', 'aaLieuHostoNbPermTot');      
              this.calculAutoTotauxA4g(index, this.valeurTableauA4g_2, 'aaLieuHostoNbPermEtp', 'aaLieuHostoNbPermEtpTot');      
              this.calculAutoTotauxA4g(index, this.valeurTableauA4g_3, 'aaLieuHostoNbVict', 'aaLieuHostoNbVictTot');      
            });
          }
        });
      this.lieuxHosto.updateValueAndValidity();
    }, 1000);

  }

  ngOnDestroy(): void {
    if (this.subLieuxHosto) {
      this.subLieuxHosto.unsubscribe();
    }
  }

  get lieuxHosto() {
    return this.rootForm.get('moyens').get('lieuxHosto') as UntypedFormArray;
  }

  public get formulaire(): UntypedFormGroup {
    return this.rootForm.get('moyens') as UntypedFormGroup;
  }

  public ajouterLieuxHosto() {
    // on récupère le nombre total avant ajout
    let nbLieux = this.formulaire.get('aaLieuHostoNb').value;

    // Pour les validators, on utilise ce qui est dans le questionnaire.metadata
    this.lieuxHosto.push(new UntypedFormGroup({
      aaLieuHostoRang: new UntypedFormControl(this.lieuxHosto.length, Validators.required),
      aaLieuHostoCodCom: new UntypedFormControl('', validationsQuestionsDynamiques.get('aaLieuHostoCodCom')),
      aaLieuHostoQp: new UntypedFormControl('', validationsQuestionsDynamiques.get('aaLieuHostoQp')),
      aaLieuHostoNbPerm: new UntypedFormControl(null, validationsQuestionsDynamiques.get('aaLieuHostoNbPerm')),
      aaLieuHostoNbPermEtp: new UntypedFormControl(null, validationsQuestionsDynamiques.get('aaLieuHostoNbPermEtp')),
      aaLieuHostoNbVict: new UntypedFormControl(null, validationsQuestionsDynamiques.get('aaLieuHostoNbVict'))
    }));
    this.step = this.lieuxHosto.length - 1 ;
    this.ajoutValidateurCroiseLieuxHosto(this.lieuxHosto.length - 1);

    // on incrémente le nombre total de lieux
    this.formulaire.get('aaLieuHostoNb').setValue(++nbLieux);
  }

  private ajoutValidateurCroiseLieuxHosto (index: number) {
    const currentForm: UntypedFormGroup = this.lieuxHosto.controls[index] as UntypedFormGroup;
    currentForm.setValidators([
      this.validationService.ctrlA72Hosto,
      this.validationService.ctrlA73Hosto
    ]);
  }

  public supprimerLieuxHosto(index?: number) {
    if (index >= 0) {
      const lieuxValeur = this.lieuxHosto.controls[index].value;
      if (confirm(`Êtes vous sûr de supprimer ${lieuxValeur['aaLieuHostoCodCom']} ?`)) {
        this.lieuxHosto.removeAt(index);
      }
    } else {
      this.lieuxHosto.removeAt(this.lieuxHosto.length - 1);
    }
    // On maj les rangs
    this.majRangs();
    // on met à jour le nombre total de lieux
    this.formulaire.get('aaLieuHostoNb').setValue(this.lieuxHosto.controls.length);
  }

  public setStep(index: number): void {
    this.step = index;
  }

  private trierLieuxHosto(): void {
    this.lieuxHosto.controls.sort((a, b) => {
      if (a.get('aaLieuHostoRang').value < b.get('aaLieuHostoRang').value) {
            return -1;
      } else if (a.get('aaLieuHostoRang').value > b.get('aaLieuHostoRang').value) {
            return 1;
      } else {
            return 0;
      }
    });
  }

  private majRangs(): void {
    for (let index = 0; index < this.lieuxHosto.length; index++) {
      this.lieuxHosto.controls[index].get('aaLieuHostoRang').setValue(index);
    }
    this.trierLieuxHosto();
  }

  private calculAutoTotauxA4g(index: number, tabBoucle: number[], varBoucle: string, totBoucle: string): void {
    tabBoucle.splice(index,1,this.lieuxHosto.controls[index].get(varBoucle).value);
    let sum = tabBoucle.reduce((a,b)=>a+b,0);
    this.formulaire.get(totBoucle).setValue(sum);
  }


}
